<div cdkTrapFocus cdkTrapFocusAutoCapture="true">
@if (title) {
<div class="modal-header">
  <h1 id="modal-header-title" class="modal-header-title">{{ title }}</h1>
</div>
} @if (alertText) {
<alert-badge [dismissIcon]="false" [isEmbedded]="true" [type]="alertStyle" [warningIcon]="true">{{
  alertText
}}</alert-badge>
}
<div class="modal-body">
  <div class="modal-body__txt">
    @if (text) {
    <p class="txt text-center">{{ text }}</p>
    } @if (textBold) {
    <p class="txt text-center bold">{{ textBold }}</p>
    } @if (textMultiLine) {
    <p class="txt text-center multi-line">{{ textMultiLine }}</p>
    } @if (textHtml) {
    <div class="txt" [innerHTML]="textHtml"></div>
    }
  </div>
</div>
<div class="modal-footer">
  <div class="buttons-box">
    <button
      [attr.aut-id]="'confirmation-modal-cancel-button'"
      class="fto-legacy-btn btn btn-default"
      type="button"
      cdkFocusInitial
      (click)="onReject()"
      data-dismiss="modal"
    >
      {{ closeText ? closeText : 'Cancel' }}
    </button>
    <button
      [attr.aut-id]="'confirmation-modal-confirm-button'"
      class="fto-legacy-btn btn btn-primary"
      [ngClass]="{ 'btn-danger': isWarningConfirmBtn }"
      type="button"
      (click)="onConfirm()"
    >
      {{ confirmText ? confirmText : 'Confirm' }}
    </button>
  </div>
</div>
</div>
